import { Box, BoxProps, CircularProgress, makeStyles } from '@material-ui/core';

import Loading from './Loading';

import { primaryGreen } from 'src/data/colors';

const useStyles = makeStyles(() => ({
  progress: {
    color: primaryGreen,
  },
}));

export interface LoadWithSpinnerProps extends BoxProps {
  message?: React.ReactNode;
  noMessage?: boolean;
  testId?: string;
}

const LoadWithSpinner = ({
  message = 'Loading',
  noMessage = false,
  testId,
  ...boxProps
}: LoadWithSpinnerProps) => {
  const classes = useStyles();

  return (
    <Box
      alignItems="center"
      data-testid={testId}
      display="flex"
      flexDirection="column"
      justifyContent="center"
      {...boxProps}
    >
      {!noMessage && <Loading message={message} />}
      <CircularProgress size={50} className={classes.progress} />
    </Box>
  );
};

export default LoadWithSpinner;
